import { createContext } from 'react';
import type { ITenant } from '@moko/utils/src/tenantHelper';

export interface TenantContextValue {
  tenant: ITenant | null;
  isLoading: boolean;
  error: Error | null;
  refresh: () => void;
}

export const TenantContext = createContext<TenantContextValue | null>(null);
